<template>
  <div class="popup-on-leave">
    <div class="text-right font-weight-bold">
      <v-icon aria-label="Close" @click="closeModal()">mdi-close</v-icon>
    </div>
    <div class="popup-on-leave-title pb-3">
      <h2 class="mb-2">ĐĂNG KÝ BẢO LƯU</h2>
      <span>(Khi bảo lưu, học sinh sẽ bị xóa khỏi lớp đang học)</span>
    </div>
    <v-form ref="form" v-if="checkAuthOnLeaveNReverse()">
      <div class="popup-on-leave-day mt-4">
        <div style="width: 45%">
          <div class="mt-3 leave-day-item">Ngày bắt đầu bảo lưu</div>
          <v-menu
            ref="startDate"
            :close-on-content-click="false"
            :nudge-top="20"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                id="myInput"
                v-model="bodyRequestForm.startDate"
                readonly
                v-bind="attrs"
                v-on="on"
                background-color="white"
                placeholder="-- / -- / ----"
                :rules="startDateRules"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="bodyRequestForm.startDate"
              @input="inputCloseDatePicker('startDate')"
              locale="vi"
              @change="checkDisableConfirm"
            ></v-date-picker>
          </v-menu>
        </div>
        <div style="width: 45%">
          <div class="mt-3 leave-day-item">Ngày đi học lại</div>
          <v-menu
            ref="endDate"
            :close-on-content-click="false"
            :nudge-top="20"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="bodyRequestForm.endDate"
                readonly
                v-bind="attrs"
                v-on="on"
                background-color="white"
                placeholder="-- / -- / ----"
                :rules="endDateRules"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="bodyRequestForm.endDate"
              @input="inputCloseDatePicker('endDate')"
              locale="vi"
            ></v-date-picker>
          </v-menu>
        </div>
      </div>
      <div class="popup-on-leave-day">
        <div style="width:93%">
          <div class="leave-day-item">Lý do bảo lưu</div>
          <v-text-field
            v-model="bodyRequestForm.reason"
            placeholder="Nhập lý do"
            background-color="white"
          ></v-text-field>
        </div>
      </div>
      <div class="popup-on-leave-confirm pt-3 pb-5 text-center">
        <v-btn
          rounded
          color="#EFF0F7"
          class="text-black btn-reserve mr-3"
          depressed
          @click="closeModal()"
        >
          Bỏ qua
        </v-btn>
        <v-btn
          rounded
          color="#FF6609"
          class="btn-reserve btn-confirm-reserve"
          depressed
          :disabled="!disableConfirm"
          @click="checkValidForm()"
        >
          Xác nhận
        </v-btn>
      </div>
    </v-form>
    <div class="popup-on-leave-history my-5">
      <p>LỊCH SỬ BẢO LƯU</p>
      <div class="popup-history mt-3" v-if="listReserveOff.length">
        <div
          v-for="(item, index) in listReserveOff"
          :key="index"
          class="time-count-history pa-2"
        >
          <div style="width:94%;display:flex">
            <span class="reservation-code text-center">{{ item.code }}</span>
            <div class="time-count-item" style="width:65%">
              <div class="mx-2">Từ </div>
              <div class="time-count-item-color">{{ item.startDate }}</div>
              <div class="mx-2"> đến </div>
              <div class="time-count-item-color">{{ item.endDate ? item.endDate : '---' }}</div>
            </div>
            <div
              class="status-reversation text-center"
              :style="
                `color: ${item.status.color};
                border: 1px solid ${item.status.color}`
              "
            >
              {{ item.status.name }}
            </div>
          </div>

          <!-- <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                class="ml-2"
                color="pink"
                v-if="checkConditionEdit(item)"
                @click="onClickEditHistory(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
          </v-menu> -->
        </div>
      </div>
      <div v-else class="text-center w-100">
        Không có dữ liệu
      </div>
    </div>
    <v-dialog v-model="deleteLastStudent" width="500" persistent>
      <v-card class="pa-5 sync-account-classin">
        <div class="close-popup"><v-icon @click="cancelDeleteStudent()">mdi-close</v-icon></div>
        <div class="title-header">
          <h3 class="text-center mt-5">
            Học sinh cuối cùng đang bị xóa. Lớp sẽ tự động kết thúc sau khi nhấn XÁC NHẬN.
          </h3>
          <h3 class="text-center mt-5">
            Bạn có chắc chắn muốn thực hiện thao tác này?
          </h3>
        </div>
        <div class="dialog-content">
          <div class="mt-3 text-center">
            <v-btn v-if="!idFormEdit" color="#069697" class="mr-2" @click="confirmCreateReservation()">xác nhận</v-btn>
            <v-btn v-else color="#069697" class="mr-2" @click="fetchUpdateReservation()">xác nhận</v-btn>
            <v-btn color="#6A2C62" class="ml-2" @click="cancelDeleteStudent()">hủy bỏ</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isEditReservation" width="600" persistent>
      <v-card class="pa-5 sync-account-classin">
        <div class="close-popup"><v-icon @click="isEditReservation = false">mdi-close</v-icon></div>
        <div class="title-header text-center">
          <h2 class="mb-2">CẬP NHẬT PHIẾU BẢO LƯU {{ reserveCode }}</h2>
          <span>(Khi cập nhật, phiếu sẽ quay lại trạng thái Chờ duyệt)</span>
        </div>
        <div class="dialog-content">
          <v-form ref="forms">
            <div class="popup-on-leave-day mt-4">
              <div>
                <div class="mt-3 leave-day-item">Ngày bắt đầu bảo lưu</div>
                <v-menu
                  ref="startDateEdit"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      id="myInput"
                      v-model="bodyEditReserve.startDate"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      disabled
                      background-color="white"
                      placeholder="-- / -- / ----"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="bodyEditReserve.startDate"
                    @input="inputCloseDatePickerEdit('startDateEdit')"
                    locale="vi"
                  ></v-date-picker>
                </v-menu>
              </div>
              <div>
                <div class="mt-3 leave-day-item">Ngày đi học lại</div>
                <v-menu
                  ref="endDateEdit"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="bodyEditReserve.endDate"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      background-color="white"
                      placeholder="-- / -- / ----"
                      :rules="bodyEditReserve.endDate ? endDateEditRules : []"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="bodyEditReserve.endDate"
                    @input="inputCloseDatePickerEdit('endDateEdit')"
                    locale="vi"
                  ></v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="popup-on-leave-day">
              <div style="width:93%">
                <div class="leave-day-item">Lý do bảo lưu</div>
                <v-text-field
                  v-model="bodyEditReserve.reason"
                  placeholder="Nhập lý do"
                  background-color="white"
                ></v-text-field>
              </div>
            </div>
            <div class="popup-on-leave-confirm pt-3 pb-5 text-center">
              <v-btn
                rounded
                color="#EFF0F7"
                class="text-black btn-reserve mr-3"
                depressed
                @click="closeEditReserve()"
              >
                Bỏ qua
              </v-btn>
              <v-btn
                rounded
                color="#FF6609"
                class="btn-reserve btn-confirm-reserve"
                depressed
                @click="confirmEdit()"
              >
                Xác nhận
              </v-btn>
            </div>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import StudentCareServices from '@/services/StudentCareServices';
import { DANG_HOC, STATUS_RESERVE } from '@/helpers/constant';

export default {
  props: {
    detailStudent: {
      type: Object,
    },
    isPopupReserve: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      idFormEdit: null,
      bodyRequestForm: {
        startDate: null,
        endDate: null,
        reason: '',
      },
      listReserveOff: [],
      startDateRules: [
        (v) => !!v || 'Ngày bắt đầu không được để trống.',
        (v) => moment(v) >= moment().startOf('day') || 'Phải lớn hơn hoặc bằng ngày hiện tại',
      ],
      endDateRules: [
        (v) => !!v || 'Ngày kết thúc không được để trống.',
        (v) => moment(v) >= moment().startOf('day') || 'Phải lớn hơn hoặc bằng ngày hiện tại',
        () => this.validateStartDateAndEndData() || 'Ngày kết thúc phải lớn hơn ngày bắt đầu',
        () => this.validate90Days() || 'Không được lớn hơn 90 ngày so với Ngày bắt đầu bảo lưu',
      ],
      endDateEditRules: [
        (v) => moment(v) >= moment().startOf('day') || 'Phải lớn hơn hoặc bằng ngày hiện tại',
        () => this.validateStartDateAndEndEditHistory() || 'Ngày kết thúc phải lớn hơn ngày bắt đầu',
      ],
      numberStudents: 0,
      deleteLastStudent: false,
      isEditReservation: false,
      bodyEditReserve: {
        startDate: null,
        endDate: null,
        reason: '',
      },
      reserveCode: '',
      firstReservedLesson: null,
      disableConfirm: true,
    };
  },

  created() {
    this.fetchReservation();
    this.fetchStudentInClass();
  },

  methods: {
    ...mapActions('student_care', ['getReservation', 'getStudentInClass']),

    // Chosen Date => Close datePicker
    inputCloseDatePicker(ref) {
      return this.$refs[ref].length ? this.$refs[ref][0].save([]) : this.$refs[ref].save([]);
    },
    inputCloseDatePickerEdit(ref) {
      return this.$refs[ref].length ? this.$refs[ref][0].save([]) : this.$refs[ref].save([]);
    },

    // Lấy danh sách lịch sử bảo lưu
    async fetchReservation() {
      const data = await this.getReservation(this.detailStudent.student_product_id);
      const res = data.reservationHistory.data;
      this.firstReservedLesson = data.firstReservedLesson;
      if (res && res.length) {
        res.map((item) => {
          const temp = item;
          temp.startDate = moment(temp.startDate, 'YYYYMMDD').format('YYYY-MM-DD').toString();
          if (temp.endDate && temp.endDate !== '') {
            temp.endDate = moment(temp.endDate, 'YYYYMMDD').format('YYYY-MM-DD').toString();
          } else {
            temp.endDate = null;
          }
          return temp;
        });
        this.listReserveOff = res;
      } else {
        this.listReserveOff = [];
      }
    },

    // check valid
    async checkValidForm() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        if (this.detailStudent.status_name === DANG_HOC && this.numberStudents === 1) {
          this.deleteLastStudent = true;
          return;
        }
        await this.confirmCreateReservation();
      }
    },

    // Tạo mới bảo lưu
    async confirmCreateReservation() {
      this.deleteLastStudent = false;
      const studentId = this.detailStudent.student_product_id;
      const res = await StudentCareServices.createReservation(studentId, this.bodyRequestForm);
      if (res.success) {
        this.$swal({
          type: 'success',
          title: 'Xác nhận bảo lưu thành công',
          timer: 1500,
        });
        this.emptyBodyRequestForm();
        this.$refs.form.resetValidation();
        this.fetchReservation();
      } else {
        this.$swal({
          type: 'error',
          title: res.message,
          timer: 3000,
        });
      }
    },

    // Cập nhật lịch sử bảo lưu
    async fetchUpdateReservation() {
      const student = {
        studentId: this.detailStudent.student_product_id,
        reservationId: this.idFormEdit,
      };
      const response = await StudentCareServices.UpdateReservation(student, this.bodyEditReserve);
      if (response.success) {
        this.$swal({
          type: 'success',
          icon: 'success',
          showConfirmButton: false,
          timer: 1500,
          title: 'Cập nhật thành công !',
        });
        this.closeEditReserve();
        await this.fetchReservation();
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: response.message ?? 'Cập nhật thất bại !',
          timer: 1500,
        });
      }
      this.cancelDeleteStudent();
    },

    async confirmEdit() {
      const isValid = this.$refs.forms.validate();
      if (isValid) {
        if (this.detailStudent.status_name === DANG_HOC && this.numberStudents === 1) {
          this.deleteLastStudent = true;
          return;
        }
        await this.fetchUpdateReservation();
      }
    },

    validate() {
      this.$refs.form.validate();
    },

    // Khi click button edit => Đóng các trạng thái edit khác
    onClickEditHistory(data) {
      this.idFormEdit = data.id;
      this.isEditReservation = true;
      this.bodyEditReserve = {
        startDate: data.startDate,
        endDate: data.endDate,
        reason: data.reason,
      };
      this.reserveCode = data.code;
    },

    closeModal() {
      Bus.$emit('closePopupReserve');
      this.listReserveOff = this.listReserveOff.map((item) => {
        const temp = item;
        return temp;
      });
      this.emptyBodyRequestForm();
      this.$refs.form.resetValidation();
    },
    closeEditReserve() {
      this.isEditReservation = false;
      this.idFormEdit = null;
      this.$refs.form.resetValidation();
    },
    validateStartDateAndEndData() {
      if (this.bodyRequestForm && this.bodyRequestForm.startDate && this.bodyRequestForm.endDate) {
        const endDate = moment(this.bodyRequestForm.endDate);
        const startDate = moment(this.bodyRequestForm.startDate);
        return endDate > startDate;
      }
      return false;
    },

    // Validate edit lịch sử bảo lưu
    validateStartDateAndEndEditHistory() {
      if (this.bodyEditReserve && this.bodyEditReserve.startDate) {
        if (this.bodyEditReserve.endDate) {
          const endDate = moment(this.bodyEditReserve.endDate);
          const startDate = moment(this.bodyEditReserve.startDate);
          return endDate > startDate;
        }
        return true;
      }
      return false;
    },

    // validate không vượt quá 90 ngày tính từ ngày bảo lưu
    validate90Days() {
      if (this.bodyRequestForm && this.bodyRequestForm.startDate) {
        if (this.bodyRequestForm.endDate) {
          const endDate = moment(this.bodyRequestForm.endDate);
          const startDate = moment(this.bodyRequestForm.startDate);
          return endDate <= startDate + (90 * 24 * 60 * 60 * 1000);
        }
        return true;
      }
      return false;
    },

    canDelete(date) {
      const now = moment();
      const dateTime = moment(date);
      return now < dateTime;
    },

    // lấy ds học sinh theo lớp bên Xếp lớp
    async fetchStudentInClass() {
      const res = await this.getStudentInClass(this.detailStudent.class_id);
      if (res && res.length) {
        this.numberStudents = res.length;
      } else {
        this.numberStudents = 0;
      }
    },
    cancelDeleteStudent() {
      this.deleteLastStudent = false;
    },
    emptyBodyRequestForm() {
      this.bodyRequestForm = {
        startDate: null,
        endDate: null,
        reason: '',
      };
      this.bodyEditReserve = {
        startDate: null,
        endDate: null,
        reason: '',
      };
    },
    checkConditionEdit(item) {
      if (item.status.id === STATUS_RESERVE.CHO_DUYET || item.status.id === STATUS_RESERVE.DA_DUYET) return true;
      return false;
    },
    checkDisableConfirm() {
      this.disableConfirm = true;
      const today = moment();
      if (this.bodyRequestForm.startDate && today.isSame(moment(this.bodyRequestForm.startDate), 'day') && this.firstReservedLesson && today.isSame(moment(this.firstReservedLesson), 'day')) {
        this.disableConfirm = false;
      }
    },
  },

  watch: {
    bodyRequestForm: {
      handler(value) {
        if (value && value.endDate && value.startDate) {
          this.validate();
        }
      },
      deep: true,
    },
    isPopupReserve: {
      handler(newVal) {
        if (newVal) {
          this.fetchReservation();
        }
      },
      deep: true,
    },
    bodyEditReserve: {
      handler(value) {
        if (value && value.endDate && value.startDate) {
          this.validate();
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.popup-on-leave, .dialog-content {
  background: #fff;
  padding: 16px;

  .popup-on-leave-title {
    width: 100%;
    text-align: center;

    span {
      color: #bdbdbd;
    }
  }

  .popup-on-leave-confirm {
    background: #f6f6f6;
  }

  .popup-history {
    .time-count-history {
      display: flex;
      width: 100%;
      border: 1px solid #E0E0E0;
    }
    .status-reversation {
      font-size: 12px;
      border-radius: 10px;
      padding: 2px 10px;
      width: 20%;
      margin: auto;
    }
    .reservation-code {
      color: #0088FF;
      width: 15%;
      margin: auto;
    }
  }

  .popup-on-leave-day {
    display: flex;
    width: 100%;
    justify-content: space-around;
    background: #f6f6f6;

    .leave-day-item {
      font-weight: 700;
    }
  }

  .text-black {
    color: black !important;
  }

  .action-edit:hover {
    background-color: #3c4858;
  }

  .action-delete:hover {
    background-color: #3c4858;
  }
}

.time-count-item {
  display: flex;
  align-items: center;

  .time-count-item-color {
    background: #FFE4E4;
    color: #FF4B4B;
    padding: 2px 7px;
    border-radius: 4px;
    font-weight: 700;
    display: flex;
    align-items: center;
  }
}
// ssd
.btn-reserve {
  text-transform: none;
  height: 24px !important;
  font-size: 12px;
  font-weight: 600;
  min-width: 95px;
}
.v-btn.v-size--default {
  padding: 3px 15px !important
}
.btn-confirm-reserve {
  color: #fff !important;
}
.popup-on-leave-history {
  p {
    font-weight: 700;
    font-size: 12px;
    color: #828282;
  }
}
.popup-on-leave-day ::v-deep .v-text-field {
  padding: 0;
}
.popup-on-leave-day ::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: 32px !important;
  border-radius: 4px;
  border-color: #fff;
  padding: 0 10px;
}
::v-deep .v-input__slot::before {
  border-style: none !important;
}
::v-deep .v-icon.v-icon {
  font-size: 16px;
}
.history-reserve {
  ::v-deep .v-text-field__slot {
    background: #e0e0e0;
    padding: 0 10px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 4px;
    width: 150px;
    height: 30px;
  }
  ::v-deep .theme--light.v-input input, .theme--light.v-input textarea {
    color: #4f4f4f;
  }
  ::v-deep .v-input__slot {
    margin-bottom: 2px;
  }
  ::v-deep .v-text-field {
    margin: 0;
  }
}
.sync-account-classin {
  .close-popup {
    position: absolute;
    right: 26px;
  }
}
.dialog-content {
  button {
    color: #fff !important;
  }
}
::v-deep .v-picker.v-card.v-picker--date.theme--light {
  margin: 0;
}
</style>
